import { render, staticRenderFns } from "./ReviewEdit.vue?vue&type=template&id=29bf0ae3&scoped=true&"
import script from "./ReviewEdit.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReviewEdit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bf0ae3",
  null
  
)

export default component.exports